var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8428 1.89966C29.8093 1.89966 30.5928 2.68316 30.5928 3.64966V7.32466C30.5928 8.29116 29.8093 9.07466 28.8428 9.07466C27.8763 9.07466 27.0928 8.29116 27.0928 7.32466V3.64966C27.0928 2.68316 27.8763 1.89966 28.8428 1.89966Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.4045 9.58809C48.0879 10.2715 48.0879 11.3795 47.4045 12.063L44.806 14.6615C44.1226 15.345 43.0145 15.345 42.3311 14.6616C41.6477 13.9781 41.6477 12.8701 42.3311 12.1867L44.9296 9.58812C45.613 8.90469 46.721 8.90468 47.4045 9.58809Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9179 28.1497C47.9179 27.1832 48.7014 26.3997 49.6679 26.3997H53.3429C54.3094 26.3997 55.0929 27.1832 55.0929 28.1497C55.0929 29.1162 54.3094 29.8997 53.3429 29.8997H49.6679C48.7014 29.8997 47.9179 29.1162 47.9179 28.1497Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3311 41.6378C43.0145 40.9543 44.1225 40.9543 44.806 41.6378L47.4045 44.2363C48.0879 44.9197 48.0879 46.0277 47.4045 46.7112C46.7211 47.3946 45.613 47.3946 44.9296 46.7112L42.3311 44.1126C41.6477 43.4292 41.6477 42.3212 42.3311 41.6378Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8428 47.2246C29.8093 47.2246 30.5928 48.0081 30.5928 48.9746V52.6496C30.5928 53.6161 29.8093 54.3996 28.8428 54.3996C27.8763 54.3996 27.0928 53.6161 27.0928 52.6496V48.9746C27.0928 48.0081 27.8763 47.2246 28.8428 47.2246Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3548 41.6378C16.0382 42.3212 16.0382 43.4292 15.3548 44.1126L12.7562 46.7112C12.0728 47.3946 10.9648 47.3946 10.2814 46.7111C9.59794 46.0277 9.59795 44.9197 10.2814 44.2363L12.8799 41.6377C13.5634 40.9543 14.6714 40.9543 15.3548 41.6378Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.59277 28.1497C2.59277 27.1832 3.37628 26.3997 4.34277 26.3997H8.01777C8.98427 26.3997 9.76777 27.1832 9.76777 28.1497C9.76777 29.1162 8.98427 29.8997 8.01777 29.8997H4.34277C3.37628 29.8997 2.59277 29.1162 2.59277 28.1497Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2814 9.5881C10.9648 8.90469 12.0728 8.90469 12.7562 9.5881L15.3548 12.1867C16.0382 12.8701 16.0382 13.9781 15.3548 14.6615C14.6714 15.345 13.5633 15.345 12.8799 14.6615L10.2814 12.063C9.59794 11.3796 9.59794 10.2715 10.2814 9.5881Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0928 28.1497C13.0928 19.4512 20.1443 12.3997 28.8428 12.3997C37.5412 12.3997 44.5928 19.4512 44.5928 28.1497C44.5928 36.8481 37.5412 43.8997 28.8428 43.8997C20.1443 43.8997 13.0928 36.8481 13.0928 28.1497ZM28.8428 15.8997C22.0773 15.8997 16.5928 21.3842 16.5928 28.1497C16.5928 34.9151 22.0773 40.3997 28.8428 40.3997C35.6082 40.3997 41.0928 34.9151 41.0928 28.1497C41.0928 21.3842 35.6082 15.8997 28.8428 15.8997Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.5ff73985.svg";
export { ForwardRef as ReactComponent };